import { render, staticRenderFns } from "./VendorSignUpForm.vue?vue&type=template&id=2dd5a54f&scoped=true&"
import script from "./VendorSignUpForm.vue?vue&type=script&lang=js&"
export * from "./VendorSignUpForm.vue?vue&type=script&lang=js&"
import style0 from "./VendorSignUpForm.vue?vue&type=style&index=0&id=2dd5a54f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5a54f",
  null
  
)

export default component.exports